<!--
 * @Description: 
 * @Author: xiaoq
 * @Date: 2024-06-13 16:04:03
 * @LastEditTime: 2024-09-14 11:22:36
 * @LastEditors: xiaoq
-->
<template>
  <div class="fimgBox min-w-1400">
    <div class="fimgBox1 min-w-1400">
      <div class="fimg1Box max-w-1400">
        <img :src="fimportedImg1" alt="" class="imgItem1" />
        <!-- <router-link to="/" class="fnav-link1"> </router-link>
        <router-link to="/about" class="fnav-link2"> </router-link>
        <router-link to="/question" class="fnav-link3"> </router-link>
        <router-link to="/protocol" class="fnav-link4"> </router-link>
        <router-link to="/protocol" class="fnav-link5"> </router-link>
        <router-link to="/protocol" class="fnav-link6"> </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import fimportedImg1 from "@/page/radonbills.maxassetcompany/components/img/footer.png";

export default {
  data() {
    return {
      fimportedImg1: fimportedImg1,
      altText: "图片",
    };
  },
  methods: {
    behave() {
      document.querySelectorAll(".Li").forEach((item) => {
        item.classList.remove("active-link");
      });
    },
    isActive(route) {
      return this.$route.path === route;
    },
    goAnchor(id) {
      const currentPath = this.$route.path;
      if (currentPath !== "/") {
        this.$router
          .push("/")
          .then(() => {
            // 确保页面跳转完成后执行下面的操作
            this.goAnchor(id);
          })
          .catch((err) => {
            // 处理跳转错误
            console.error("跳转错误", err);
          });
      }

      var anchor = document.getElementById(id);

      if (anchor) {
        anchor.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "start", // 滚动到元素顶部
        });
        anchor.scrollTo({ top: 0, behavior: "smooth" });

        document.querySelectorAll(".Li").forEach((item) => {
          item.classList.remove("active-link");
        });

        document.querySelector(`.${id}`).classList.add("active-link");
        // console.log(document.querySelectorAll('Li'));
      }
    },
  },
};
</script>

<style scoped>
.fimgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.fimgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.fimg1Box {
  width: 100%;
  overflow: hidden;
  background-color: "";
}

.fimg1Box {
  position: relative;
  margin-top: -2px;
}
.fnav-link1,
.fnav-link2,
.fnav-link3,
.fnav-link4,
.fnav-link5,
.fnav-link6 {
  /* border: 1px solid red; */
  position: absolute;
  cursor: pointer;
}

.fnav-link1 {
  top: 28%;
  left: 58%;
  width: 8%;
  height: 9%;
}
.fnav-link2 {
  top: 28%;
  left: 72%;
  width: 11%;
  height: 9%;
}
.fnav-link3 {
  top: 39.5%;
  left: 58%;
  width: 9%;
  height: 9%;
}
.fnav-link4 {
  top: 39.5%;
  width: 11%;
  left: 72%;
  height: 9%;
}
.fnav-link5 {
  top: 52%;
  left: 58%;
  width: 12%;
  height: 9%;
}

.fnav-link6 {
  top: 52%;
  left: 72%;
  width: 13%;
  height: 9%;
}
</style>
